module.exports = __webpack_public_path__ + "static/img/小熊台灯.2f22481.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/小熊台灯.png
// module id = rGB4
// module chunks = 2